export default __webpack_public_path__ + "static/media/typeS_low_lamp.b8145f33.png";